import {SsbDataInt, SSBDDataTrasformInt} from "@app/interfaces/micro/ssbd.interface";

export class SsbdData {
  static transform(value: string, dictionary: any): SSBDDataTrasformInt {
    const data: SSBDDataTrasformInt = {
      BS: '',
      BT: '',
      weightNunit: '',
      height: 0,
      large: 0,
      SW: '',
      width: 0,
      ticket: '',
      weight: 0,
      unit: 'KG',
      bagStatus: '',
      bagType: '',
      scaleWeight: '',
      statusDevice: '',
    };

    const params = value.split('#');
    // Valia si la maleta esta bien puesta o colgando del borde.
    data.readStatus = SsbdData.parseReadStatus(params[0] ?? '');
    params
      .filter((_, index) => index > 0)
      .forEach((param) => {
        const [key, val] = param.split('=');
        const keyTransform = dictionary[key] || key;

        if (keyTransform === 'weightNunit') {
          data.weightNunit = val;
          if (val) {
            const match = val.match(/^(\d+\.?\d*)([A-Za-z]+)$/);
            if (match) {
              data.weight = Math.floor(Number(match[1]));
              data.unit = match[2];
            }
          }
        } else if (['height', 'width', 'large'].includes(keyTransform)) {
          if (val) {
            const match = val.match(/^(\d+\.?\d*)/);
            if (match) {
              (data as any)[keyTransform] = Math.floor(Number(match[1]));
            }
          }
        } else {
          (data as any)[keyTransform] = val;
        }
      });
    return data;
  }

  /* Extrae el estado de respuesta del primer token del mensaje AEA.*/
  private static parseReadStatus(header: string): string {
    if (!header) {
      return '';
    }
    const normalized = header.trim().toUpperCase();
    if (normalized.length < 2) {
      return '';
    }
    return normalized.slice(-2);
  }
}
